import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ palette }) => ({
  logo: {
    height: '31px',
    width: 'auto',
    display: 'block'
  },
  fallbackText: {
    color: palette.text.disabled
  }
}))
